module.exports = __webpack_public_path__ + "media/images/pc/reports/main_visual_05-47620d5a06c6f3444e78adb7105e75dc.jpg";